module.exports = __webpack_public_path__ + "img/freeContent-arrow.c8f324c3.svg";